export const isDoubleFaced = (card) => card?.card_faces && !card?.image_uris;

export const getSmallImageUri = (card, faceIndex = 0) => {
  if (card?.image_uris?.small) {
    return card.image_uris.small;
  }
  if (card?.card_faces?.[faceIndex]?.image_uris?.small) {
    return card.card_faces[faceIndex].image_uris.small;
  }
  return null;
};

export const getNormalImageUri = (card, faceIndex = 0) => {
  if (card?.image_uris?.normal) {
    return card.image_uris.normal;
  }
  if (card?.card_faces?.[faceIndex]?.image_uris?.normal) {
    return card.card_faces[faceIndex].image_uris.normal;
  }
  return null;
};

export const getOracleText = (card) => {
  if (card?.oracle_text) {
    return card.oracle_text;
  }
  if (card?.card_faces) {
    return card.card_faces
      .map(face => `${face.name}:\n${face.oracle_text || ''}`)
      .join('\n\n');
  }
  return null;
};

export const getManaCost = (card, faceIndex = 0) => {
  if (card?.mana_cost) {
    return card.mana_cost;
  }
  if (card?.card_faces?.[faceIndex]?.mana_cost) {
    return card.card_faces[faceIndex].mana_cost;
  }
  return '—';
};
